module.exports = __webpack_public_path__ + "static/img/beidouxing.856b5f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/man/banner/beidouxing.jpg
// module id = Jpum
// module chunks = 0